import { render, staticRenderFns } from "./ClassTrialBehaviorTableForm.vue?vue&type=template&id=116bc5cf"
import script from "./ClassTrialBehaviorTableForm.vue?vue&type=script&lang=js"
export * from "./ClassTrialBehaviorTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports